"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFilenameSecurity = validateFilenameSecurity;
exports.getBlockedExtensions = getBlockedExtensions;
const BLOCKED_EXTENSIONS = [
    '.exe',
    '.dll',
    '.so',
    '.dylib',
    '.app',
    '.bat',
    '.cmd',
    '.com',
    '.msi',
    '.scr',
    '.js',
    '.vbs',
    '.vbe',
    '.wsf',
    '.wsh',
    '.ps1',
    '.psm1',
    '.psd1',
    '.sh',
    '.bash',
    '.zsh',
    '.fish',
    '.git',
    '.svn',
    '.hg',
    '.DS_Store',
    '.gitignore',
    '.gitattributes',
    '.jar',
    '.war',
    '.ear',
    '.reg',
    '.inf',
    '.cpl',
    '.scf',
    '.lnk',
    '.url',
    '.desktop',
];
const DANGEROUS_PATTERNS = [
    /\.\./,
    /^\.+$/,
    /[\x00-\x1f]/,
    /[<>:"|?*]/,
];
function validateFilenameSecurity(filename) {
    if (!filename || filename.trim().length === 0) {
        return { isValid: false, reason: 'Filename is empty' };
    }
    const normalizedFilename = filename.toLowerCase().trim();
    for (const ext of BLOCKED_EXTENSIONS) {
        if (normalizedFilename.endsWith(ext.toLowerCase())) {
            return { isValid: false, reason: `File type ${ext} is not allowed for security reasons` };
        }
    }
    for (const pattern of DANGEROUS_PATTERNS) {
        if (pattern.test(filename)) {
            return { isValid: false, reason: 'Filename contains invalid characters or patterns' };
        }
    }
    if (filename.length > 255) {
        return { isValid: false, reason: 'Filename is too long (max 255 characters)' };
    }
    return { isValid: true };
}
function getBlockedExtensions() {
    return BLOCKED_EXTENSIONS;
}
//# sourceMappingURL=file-security.js.map